import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
      {items.map((item, index) => (
        <span key={item.label} className="flex items-center gap-1.5">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
          )}
          {item.path ? (
            <Link
              to={item.path}
              className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-400">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}